import { render, staticRenderFns } from "./donut-transaction-by-type.vue?vue&type=template&id=71f28576&"
import script from "./donut-transaction-by-type.vue?vue&type=script&lang=js&"
export * from "./donut-transaction-by-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports